import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'swiper/css/swiper.css'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import store from './store'
import _ from 'lodash'
import {
  Button,
  Loading,
  Image,
  Dialog,
  Input,
  Form,
  FormItem,
  MessageBox,
  Message,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popover,
  Slider,
  Upload,
  CheckboxGroup,
  Checkbox,
  Drawer,
  Tag,
  Tree,
  Switch,
  InputNumber,
  Popconfirm
} from 'element-ui'
import VueCropper from 'vue-cropper'

Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Button)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Popover)
Vue.use(Slider)
Vue.use(Upload)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Drawer)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Switch)
Vue.use(InputNumber)
Vue.use(Loading.directive)
Vue.use(Popconfirm)

Vue.use(mavonEditor)
Vue.use(VueCropper)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message
Vue.config.productionTip = false
Vue.prototype._ = _

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
